import { atom } from 'recoil'

export const mobileMenuState = atom({
  key: 'mobileMenuState',
  default: false
})

export const communityMenuItems = [
  {
    label: 'Australian Heritage',
    description: 'Metalcorp is an institution in the Australian bush',
    href: '/community/australian-heritage'
  },
  {
    label: 'Events & Field Days',
    description: 'Metalcorp regularly run events and field days to support rural communities',
    href: '/community/events-field-days'
  },
  {
    label: 'National Centre for Farmer Health',
    description: 'Metalcorp has teamed up with the National Centre for Farmer Health (NCFH) to make a difference',
    href: '/community/national-centre-farmer-health'
  },
  {
    label: 'Tick Of Approval',
    description: 'Safe Farming Tick Of Approval by the National Centre for Farmer Health',
    href: '/community/tick-approval'
  },
  {
    label: 'Careers',
    description: 'We strongly believe that people are the essential foundation',
    href: 'https://careers.orrcon.com.au',
    external: true
  },
]

export const resourceMenuItems = [
  {
    label: 'News & Updates',
    description: 'Keep up-to-date with news & promotions',
    href: '/resources/news-updates'
  },
  {
    label: 'Certificates',
    description: 'Operation and product certificates',
    href: '/resources/certificates'
  },
  {
    label: 'Safety Data Sheets',
    description: 'Discover our range of safety data sheets',
    href: '/resources/safety-data-sheets'
  },
  {
    label: 'Product & Technical Resources',
    description: 'For all product info sheets',
    href: '/resources/technical-resources'
  },
  {
    label: 'Frequently Asked Questions',
    description: 'See a list of frequently asked questions',
    href: '/resources/faqs'
  },
  {
    label: 'Catalogues & Brochures',
    description: 'Our products can be cut to length and delivered to site',
    href: '/resources/catalogues-brochures'
  },
  {
    label: 'Credit Application',
    description: 'Opening a Commercial Credit account with Metalcorp',
    href: '/resources/credit-application'
  },
  {
    label: 'Pickup And Delivery',
    description: 'Pickup and delivery items to note',
    href: '/resources/pickup-and-delivery'
  },
  {
    label: 'Terms of Sale',
    description: 'Terms & conditions of sale',
    href: 'https://orrcon-static-assets.s3.ap-southeast-2.amazonaws.com/s3fs-public/2023-10/Orrcon%20Distribution%20Sales%20Terms%20and%20Conditions.pdf',
    external: true
  },
  /*{
    label: 'Safety Data Sheets',
    description: 'Discover our range of safety data sheets relevant to our products',
    href: '/resources/safety-data-sheets'
  },*/
]

export const productMenuItems = [
  {
    label: 'Tubular Steel',
    description: 'A range of tubular steel products to suit your needs',
    href: '/products/tubular-steel'
  },
  {
    label: 'Structural & Merchant Bar',
    description: 'Structural and merchant bars products including channels, angles, flats & more',
    href: '/products/structural-merchant-bar'
  },
  {
    label: 'Livestock Handling',
    description: 'Yard and handling equipment for cattle, sheep, goat and horses',
    href: '/products/livestock-handling'
  },
  {
    label: 'Fencing',
    description: 'A range of plain and barb wire, farm gates and accessories',
    href: '/products/fencing'
  },
  {
    label: 'Accessories',
    description: 'Accessories including paint, welding, grinding and restraints',
    href: '/products/other'
  },
  {
    label: 'All Products',
    description: 'View our complete range of quality steel products',
    href: '/products/all'
  }
]
